var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{attrs:{"id":"localisation-handler"}})
}
var staticRenderFns = []

export { render, staticRenderFns }